import { ProgramModule_mkProgram, ProgramModule_run } from "./.fable/Fable.Elmish.3.1.0/program.fs.js";
import { Program_withReactBatched } from "./.fable/Fable.Elmish.React.3.0.1/react.fs.js";
import { fableModule } from "./Global.fs.js";
import { ProgramModule_toNavigable } from "./.fable/Fable.Elmish.Browser.3.0.4/navigation.fs.js";
import { parseHash } from "./.fable/Fable.Elmish.Browser.3.0.4/parser.fs.js";
import { update, init, urlUpdate, route as route_1 } from "./TagungsProgramm/State.fs.js";
import { render } from "./TagungsProgramm/View.fs.js";

ProgramModule_run(Program_withReactBatched(fableModule.Platzhalter, ProgramModule_toNavigable((location) => parseHash(route_1, location), (route, model_2) => urlUpdate(route, model_2), ProgramModule_mkProgram((result) => init(result), (msg, model) => update(msg, model), (model_1, dispatch) => render(model_1, dispatch)))));

